webpackJsonp([181547840425104],{

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PULL_OVERS = [{
	  id: 'orange-pull-over',
	  color: 'orange',
	  img_src: '/img/products/2022/PRM90HT-orange.jpg'
	}, {
	  id: 'charcoal-pull-over',
	  color: 'charcoal',
	  img_src: '/img/products/2022/PRM90HT-charcoal.jpg'
	}, {
	  id: 'light-grey-pull-over',
	  color: 'light-grey',
	  img_src: '/img/products/2022/PRM90HT-light-grey.jpg'
	}, {
	  id: 'navy-pull-over',
	  color: 'navy',
	  img_src: '/img/products/2022/PRM90HT-navy.jpg'
	}, {
	  id: 'sky-pull-over',
	  color: 'sky',
	  img_src: '/img/products/2022/PRM90HT-sky.jpg'
	}, {
	  id: 'burgundy-pull-over',
	  color: 'burgundy',
	  img_src: '/img/products/2022/PRM90HT-burgundy.jpg'
	}];
	
	var ZIP_UPS = [{
	  id: 'orange-zip-up',
	  color: 'orange',
	  img_src: '/img/products/2022/PRM90HTZ-orange.jpg'
	}, {
	  id: 'charcoal-zip-up',
	  color: 'charcoal',
	  img_src: '/img/products/2022/PRM90HTZ-charcoal.jpg'
	}, {
	  id: 'light-grey-zip-up',
	  color: 'light-grey',
	  img_src: '/img/products/2022/PRM90HTZ-light-grey.jpg'
	}, {
	  id: 'navy-zip-up',
	  color: 'navy',
	  img_src: '/img/products/2022/PRM90HTZ-navy.jpg'
	}, {
	  id: 'sky-zip-up',
	  color: 'sky',
	  img_src: '/img/products/2022/PRM90HTZ-sky.jpg'
	}, {
	  id: 'burgundy-zip-up',
	  color: 'burgundy',
	  img_src: '/img/products/2022/PRM90HTZ-burgundy.jpg'
	}];
	
	var T_SHIRTS = [{
	  id: 'teal-t-shirt',
	  color: 'teal',
	  img_src: '/img/products/2022/6210-teal.jpg'
	}, {
	  id: 'purple-rush-t-shirt',
	  color: 'purple rush',
	  img_src: '/img/products/2022/6210-purple-rush.jpg'
	}];
	
	var ApparelPage = function ApparelPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'product-page' },
	    _react2.default.createElement(
	      'div',
	      { className: 'section section-gray', style: { paddingTop: 100, paddingBottom: 500 } },
	      _react2.default.createElement(
	        'main',
	        { className: 'container', style: { maxWidth: 1000 } },
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement('meta', { charSet: 'utf-8' }),
	          _react2.default.createElement(
	            'title',
	            null,
	            'CrossFit Secaucus Apparel'
	          ),
	          _react2.default.createElement('meta', { name: 'description', content: 'Get your CrossFit Secaucus apparel today.' }),
	          _react2.default.createElement('meta', { property: 'og:title', content: 'CrossFit Secaucus Apparel' }),
	          _react2.default.createElement('meta', { property: 'og:description', content: 'Get your CrossFit Secaucus apparel today.' }),
	          _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	          _react2.default.createElement('meta', { property: 'og:url', content: 'https://crossfit-secaucus.com/apparel' }),
	          _react2.default.createElement('meta', { property: 'og:image', content: 'https://crossfit-secaucus.com/img/products/2020/tshirts.jpg' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main main-raised main-product' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'tab-content' },
	                PULL_OVERS.map(function (hoodie, index) {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: 'tab-pane show ' + (index === 0 ? 'active' : ''), id: hoodie.id },
	                    _react2.default.createElement('img', { src: hoodie.img_src })
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'nbs-flexisel-container' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'nbs-flexisel-inner' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'nav flexi-nav nbs-flexisel-ul', style: { width: '100%' }, 'data-tabs': 'tabs' },
	                    PULL_OVERS.map(function (hoodie) {
	                      return _react2.default.createElement(
	                        'li',
	                        { className: 'nav-item nbs-flexisel-item', style: { width: 100 } },
	                        _react2.default.createElement(
	                          'a',
	                          { href: '#' + hoodie.id, className: 'nav-link', 'data-toggle': 'tab' },
	                          _react2.default.createElement('img', { src: hoodie.img_src })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: { fontSize: 12, marginTop: -10, paddingBottom: 10 } },
	                          hoodie.color
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'title' },
	                '2022 Pull-over Hoodie'
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'main-price' },
	                '$49.99 \u2013 ',
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'Pre-sale Only'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://clients.mindbodyonline.com/classic/ws?studioid=40911&stype=43&catid=26&prodGroupId=10707', className: 'btn btn-success' },
	                  'Pre-Order',
	                  _react2.default.createElement('div', { 'class': 'ripple-container' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'tshirtAccordion', role: 'tablist' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card card-collapse' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header', role: 'tab' },
	                    _react2.default.createElement(
	                      'h5',
	                      { className: 'mb-0' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'data-toggle': 'collapse', href: '#tshirtCollapseOne', 'aria-expanded': 'false', 'aria-controls': 'tshirtCollapseOne', className: 'collapsed' },
	                        'Description',
	                        _react2.default.createElement(
	                          'i',
	                          { className: 'material-icons' },
	                          'keyboard_arrow_down'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { id: 'tshirtCollapseOne', className: 'collapse show', role: 'tabpanel', 'data-parent': '#tshirtAccordion' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-body' },
	                      _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          '7.5 oz (250 gm) pre-laundered 70% cotton/30% polyester blend french terry'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'ring spun cotton'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'split stitch double needle sewing'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          '1x1 ribbing at cuffs, waistband, and side panels'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'antique nickel eyelets'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'two antique nickel tipped flat drawcords'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'media pocket and eyelet in front pocket'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'thumbholes at cuffs'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'twill neck tape'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'V notch'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'slim unisex fit'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement('img', { src: 'https://cdn.shopify.com/s/files/1/0055/1242/files/prm90htc.jpg', width: '100%' })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main main-raised main-product', style: { top: 100 } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'tab-content' },
	                ZIP_UPS.map(function (hoodie, index) {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: 'tab-pane show ' + (index === 0 ? 'active' : ''), id: hoodie.id },
	                    _react2.default.createElement('img', { src: hoodie.img_src })
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'nbs-flexisel-container' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'nbs-flexisel-inner' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'nav flexi-nav nbs-flexisel-ul', style: { width: '100%' }, 'data-tabs': 'tabs' },
	                    ZIP_UPS.map(function (hoodie) {
	                      return _react2.default.createElement(
	                        'li',
	                        { className: 'nav-item nbs-flexisel-item', style: { width: 100 } },
	                        _react2.default.createElement(
	                          'a',
	                          { href: '#' + hoodie.id, className: 'nav-link', 'data-toggle': 'tab' },
	                          _react2.default.createElement('img', { src: hoodie.img_src })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: { fontSize: 12, marginTop: -10, paddingBottom: 10 } },
	                          hoodie.color
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'title' },
	                '2022 Zip-up Hoodie'
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'main-price' },
	                '$49.99 \u2013 ',
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'Pre-sale Only'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://clients.mindbodyonline.com/classic/ws?studioid=40911&stype=43&catid=26&prodGroupId=10743', className: 'btn btn-success' },
	                  'Pre-Order',
	                  _react2.default.createElement('div', { 'class': 'ripple-container' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'zipUpAccordion', role: 'tablist' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card card-collapse' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header', role: 'tab' },
	                    _react2.default.createElement(
	                      'h5',
	                      { className: 'mb-0' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'data-toggle': 'collapse', href: '#zipUpCollapseOne', 'aria-expanded': 'false', 'aria-controls': 'zipUpCollapseOne', className: 'collapsed' },
	                        'Description',
	                        _react2.default.createElement(
	                          'i',
	                          { className: 'material-icons' },
	                          'keyboard_arrow_down'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { id: 'zipUpCollapseOne', className: 'collapse show', role: 'tabpanel', 'data-parent': '#zipUpAccordion' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-body' },
	                      _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          '7.5 oz (250 gm) pre-laundered 70% cotton/30% polyester blend french terry'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'ring spun cotton'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'split stitch double needle sewing'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          '1x1 ribbing at cuffs and waistband'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'antique nickel tipped flat drawcord'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'media pocket and eyelet in front pocket'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'thumbholes at cuffs'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          'twill neck tape'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'slim unisex fit'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement('img', { src: 'https://cdn.shopify.com/s/files/1/0055/1242/files/prm90htc.jpg', width: '100%' })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main main-raised main-product', style: { top: 200 } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'tab-content' },
	                T_SHIRTS.map(function (tshirt, index) {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: 'tab-pane show ' + (index === 0 ? 'active' : ''), id: tshirt.id },
	                    _react2.default.createElement('img', { src: tshirt.img_src })
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'nbs-flexisel-container' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'nbs-flexisel-inner' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'nav flexi-nav nbs-flexisel-ul', style: { width: '100%' }, 'data-tabs': 'tabs' },
	                    T_SHIRTS.map(function (tshirt) {
	                      return _react2.default.createElement(
	                        'li',
	                        { className: 'nav-item nbs-flexisel-item', style: { width: 100 } },
	                        _react2.default.createElement(
	                          'a',
	                          { href: '#' + tshirt.id, className: 'nav-link', 'data-toggle': 'tab' },
	                          _react2.default.createElement('img', { src: tshirt.img_src })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: { fontSize: 12, marginTop: -10, paddingBottom: 10 } },
	                          tshirt.color
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'title' },
	                '2022 T-shirt'
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'main-price' },
	                '$19.99 \u2013 ',
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'Pre-sale Only'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://clients.mindbodyonline.com/classic/ws?studioid=40911&stype=43&catid=26&prodGroupId=10779', className: 'btn btn-success' },
	                  'Pre-Order',
	                  _react2.default.createElement('div', { 'class': 'ripple-container' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'tshirtAccordion', role: 'tablist' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card card-collapse' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-header', role: 'tab' },
	                    _react2.default.createElement(
	                      'h5',
	                      { className: 'mb-0' },
	                      _react2.default.createElement(
	                        'a',
	                        { 'data-toggle': 'collapse', href: '#tshirtCollapseOne', 'aria-expanded': 'false', 'aria-controls': 'tshirtCollapseOne', className: 'collapsed' },
	                        'Description',
	                        _react2.default.createElement(
	                          'i',
	                          { className: 'material-icons' },
	                          'keyboard_arrow_down'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { id: 'tshirtCollapseOne', className: 'collapse show', role: 'tabpanel', 'data-parent': '#tshirtAccordion' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'card-body' },
	                      _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Fabric: '
	                          ),
	                          '60% combed ring-spun cotton, 40% polyester'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Fabric weight: '
	                          ),
	                          '145g, 4.3oz'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Collar: '
	                          ),
	                          'crew neck'
	                        ),
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Fit: '
	                          ),
	                          'type classic'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ApparelPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-apparel-js-d74751ec5e51264be790.js